import { z } from 'zod';

export const householdInputsSchema = z.object({
    annualSpendingInRetirement: z.string().min(1, 'Required'),
    targetSuccessLikelihood: z.string().min(1, 'Required'),
    taxFilingStatus: z.string().min(1, 'Required'),
    residentialLocation: z.string().min(1, 'Required'),
    currentMarginalTaxRate: z.string().nullish(),
    retirementContributionWaterfall: z
        .array(
            z.object({
                memberId: z.string().min(1, 'Member ID is required'),
                contributions: z.record(z.string(), z.string()),
            }),
        )
        .nullish(),
});

export const memberInputsSchema = z.object({
    currentAge: z.string().min(1, 'Required'),
    retirementAge: z.string().min(1, 'Required'),
    socialSecurityBenefitAge: z.string().min(1, 'Required'),
    lifeExpectancy: z.string().min(1, 'Required'),
    currentGrossAnnualIncome: z.string().min(1, 'Required'),
    hasEmployerRetirementPlan: z.boolean(),
    employerMatchMaximumPercentOfIncome: z.string().nullish(),
    employerMatchPercentage: z.string().nullish(),
    isSelfEmployed: z.boolean(),
    annualSocialSecurityBenefit: z.string().nullish(),
    includeRetirementHealthcareCosts: z.boolean(),
    retirementHealthcareCost: z.string().min(1, 'Required'),
    longTermCareCost: z.string().min(1, 'Required'),
    accounts: z.array(
        z.object({
            id: z.string().min(1, 'Required'),
            type: z.string().min(1, 'Required'),
            balance: z.string().min(1, 'Required'),
            equitiesPercentage: z.string().min(1, 'Required'),
            costBasis: z.string().min(1, 'Required'),
        }),
    ),
});

export const retirementCalculatorFormSchema = z.object({
    householdInputs: householdInputsSchema,
    primaryMember: memberInputsSchema,
    partnerMember: memberInputsSchema.optional(),
});

// Type exports
export type RetirementCalculatorFormData = z.infer<
    typeof retirementCalculatorFormSchema
>;
